import React from 'react'
import CustomLayout from 'components/layout-components/CustomLayout'
import UserViews from 'views/user-views'

const UserLayout = () => <CustomLayout views={UserViews} />

export default UserLayout
